import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'app/core/mips/common/services/local-storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip the MSAL login endpoint - this endpoint doesn't require authentication
    if (request.url.includes('/api/msal-login')) {
      return next.handle(request);
    }

    if (request.headers.has('Authorization')) {
      return next.handle(request);
    }

    // First try MSAL_JWT_TOKEN, then API_KEY for backward compatibility
    const jwtToken = LocalStorageService.getLocalStorageValueBasedOnKeys('MSAL_JWT_TOKEN') ||
                     LocalStorageService.getLocalStorageValueBasedOnKeys('API_KEY');

    if (jwtToken) {
      const authRequest = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${jwtToken}`)
      });
      return next.handle(authRequest);
    }

    return next.handle(request);
  }
}
